import React, {
      Component
} from 'react';
import Util from '../../util.js';
import {
      connect
} from 'react-redux';
import {
      getSupperFundHome,
      getHistoryIcomeListSuper
} from '../../action/investmentAction';
import { AlerModleQy,AlerModleCommonn,AlerModleUpgrade } from './AlerModle';

import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
import { compareDate, compareTime, getDateNow, get3MonthBefor, get1yearBefor, getOneMonthBefor, getSixMonthBefor, getDateS} from '../../getPay';

import {
      hashHistory
} from 'react-router';
import NavigatorMain from '../NavigatorMain';

let width = window.screen.width 

let historyD = {
      "code": "0000",
      "message": null,
      "content": {
            "HistoryRate": [{
                  "fund_type": "1",
                  "fund_name": "华夏移动互联混合（QDII）",
                  "code": "002891",
            }]
      }
}

       
/*智投持仓列表*/
class SuperFundList extends Component {
      constructor(props) {
            super(props);
            this.state = {
                  modalFlag: false,
                  tabName: "持有组合"
                  ,
              tipFlag:false

            };
      }
      componentWillMount() {
        document.title = '我的智投账户'
        let {
              dispatch
        } = this.props;
        dispatch(getSupperFundHome({}, (data) => {}, this))
      }
      ProtocolPaper() {
            hashHistory.push({
                  pathname: '/Transfer',
                  state: {
                        name: '调整组合',
                        type: 1
                  },
                  query: {
                        code: ''
                  }
            })
      }

      goBack() {
            hashHistory.push({
                  pathname: '/',
            })
      }

      goInvesting() {
            this.setState({
                  modalFlag: true
            })
      }

      goTransactionRecord() {
        window._czc.push(["_trackEvent", "华夏财富H5", "我的智投账户", "交易记录按钮"]);
            hashHistory.push({
                  pathname: '/TransactionRecord',
                  state: {
                        pathName: "/SuperFundList"
                  }
            })
      }
      goDetail(superFundCode, superFundType) {
            let SupperFundHome = this.props.SupperFundHome;
            let pathName = "";
            if(superFundType === "1") {
              pathName='/TargetProfitHaveCast'
            }else {
              pathName='/SuperFundDetailHaveCast'
            }

            hashHistory.push({
                  pathname: pathName,
                  state: {
                        superFundCode: superFundCode
                  },
                  query: {
                        superFundCode: superFundCode
                  }
            })
      }
      tabClick(data) {
            this.setState({
                  tabName: data
            })
      }
      goHistoryProfit() {
            let SupperFundHome = this.props.SupperFundHome;
            let data = SupperFundHome ? (this.props.SupperFundHome.singleSuperFundViews ? this.props.SupperFundHome.singleSuperFundViews : []) : [];
            hashHistory.push({
                  pathname: '/HistoryProfit',
                  state: {
                        SuperList: data,
                  },
                  query: {
                        SuperList: "",
                  }
            })
      }
      render() {
            //let  = this.props.location.state.data;
            
            let SupperFundHome = this.props.SupperFundHome;
            let data = SupperFundHome ? (this.props.SupperFundHome.singleSuperFundViews ? this.props.SupperFundHome.singleSuperFundViews : []) : [];
            console.log(data, "智投持仓列表智投持仓列表智投持仓列表")
            let {
                  tabName
            } = this.state;
            return (
                  <div className="container">
          <NavigatorMain>
          <div className="header">
            <div> <span className="headerLeftBtn"  onClick={ ()=> this.goBack() }></span></div>
            <div className="MyZh_div" >我的智投账户</div>
            <div className="MyJy_div" onClick={ ()=>{ this.goTransactionRecord() } }>交易记录</div>    
          </div>
          </NavigatorMain>
          <div className='content' >
            <div className="headerShow" >
                <div style={{ marginTop:'0.24rem'}} >
                  <div style={{ fontSize:"0.24rem",color:"#aebad7"}}>智投总金额(元)</div>
                  <div style={{ fontSize:"0.56rem" }}>
                    {
                      SupperFundHome? Util.parsePrice(SupperFundHome.totalAssets) : null
                    }
                  </div>
                </div>
                  
                <div className="transitAssetsShow">

                </div>
              
                <div className="headerShowTwo" >
                  <div className="classCenter" onClick = { ()=> this.goHistoryProfit() } >
                    <div>
                      { 
                        SupperFundHome ? ( "最新收益("+ (SupperFundHome.deadLine != null? SupperFundHome.deadLine : "--") + ")" ) : "" 
                      }
                       <a onClick={(event)=>{event.stopPropagation(),this.setState({tipFlag:true})}}> 
                                  <img style={{
                                    height:"0.32rem",
                                    width: "0.32rem",
                                    color: "#FA063A",
                                    lineHeight: "0.42rem",
                                    marginBottom:"-0.09rem",
                                    marginLeft: 2
                                  }} src={require("../../img/wenhao3.png")} />
                         </a>   
                     </div>
                    <div>
                      {
                        SupperFundHome? Util.fomatFloat(SupperFundHome.dayIncome) : null
                      }
                    </div>
                  </div>
                  <div style={{width:"1px",backgroundColor:'rgba(255,255,255,0.35)',height:"1.4rem"}}>
                    
                  </div>
                  <div className="classCenter" onClick = { ()=> this.goHistoryProfit() } >
                    <div>累计收益</div>
                    <div>
                    {
                      SupperFundHome? Util.fomatFloat(SupperFundHome.allIncome) : null
                    }
                    </div>
                  </div>
                </div>
            </div>

            <div className="">
              <div className="cyzh_div">
                <div className={ tabName === "持有组合" ? "tabClickList" : "tabDefaultList" } onClick={ () => this.tabClick("持有组合") }>
                  <span>持有组合</span>
                </div>
                <div className={ tabName === "收益表现" ? "tabClickList" : "tabDefaultList" } onClick={ ()=> { this.tabClick("收益表现") }}>
                  <span>收益表现</span>
                </div>
              </div>
            </div>
            
           
              <div style={{ display:this.state.tabName === "持有组合"? "block" : "none"}} >
                {
                  data.map((item, index)=>{
                    return(
                      <div className="superListZh" onClick={ ()=>{ this.goDetail(item.superFundCode, item.superFundType) }} >
                        <div><span style={{color:"#3a3e47"}}>{ item.superFundName }</span><span></span></div>
                        <div>
                          <div className="flexPadding">
                            <div style={{fontSize:14, color:"#000" }}>
                              { 
                                item.adjustFlag || item.buyFlag ? null : null
                              }
                              { 
                                !item.adjustFlag && !item.buyFlag ? Util.newToFixed(item.currentAsset) + "元" : null
                              }
                              {
                                item.adjustFlag ? "调仓中" : null
                              }
                              {
                                item.buyFlag ? "申购中" : null
                              }
                            </div>
                            <div style={{fontSize:12, color:"#AEA7B2" }}>当前资产</div>
                          </div>
                          <div style={{ width:1, height:30, backgroundColor:"#f2f4f7" }}></div>
                          <div className="flexPadding" >
                            <div style={{ color:Util.newToFixed(item.dayIncome) >=0 ? "#fa063a" : "#7fdd81", fontSize:14 }}>


                              { Util.newToFixed(item.dayIncome) > 0 ? "+" +  Util.newToFixed(item.dayIncome) + "元" : Util.newToFixed(item.dayIncome) + "元" }
                            </div>
                            <div style={{ fontSize:12, color:"#AEA7B2" }}>最新收益(元)</div>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>

              <div  style={{ display : this.state.tabName === "持有组合"? "none" : "block", background:"#FFF" }} >
                <TabLineComponent  dispatch={ this.props.dispatch }/>
                <div className="pushMore_div">
                  <div onClick = { ()=> this.goHistoryProfit() } style={{ height:"30px", width:100, backgroundColor:"#fa063a", borderRadius:200, color:"#FFF", textAlign:'center', lineHeight:"30px" }}>
                    查看更多
                  </div>
                </div>
              </div>

            
            
          </div>

          { /*
            data.length !== 0?
            data.map((item,i)=>{
              return(
                <div className="superList" onClick={ ()=>{ this.goDetail(item.superFundCode) }} key = { i }>
                  <div><span>{ item.superFundName }</span><span></span></div>
                  <div>
                    <span>当前资产</span>
                    <span>
                      { 
                        item.adjustFlag || item.buyFlag ? null : null
                      }
                      { 
                        !item.adjustFlag && !item.buyFlag ? Util.newToFixed(item.currentAsset) + "元" : null
                      }
                      {
                        item.adjustFlag ? "调仓中" : null
                      }
                      {
                        item.buyFlag ? "申购中" : null
                      }
                    </span>
                  </div>
                  <div>
                    <span>最新收益</span>
                    <span>
                      {
                        Util.newToFixed(item.dayIncome)  != "--" ? Util.newToFixed(item.dayIncome) + "元" : "--"
                      }
                    </span>
                  </div>
                </div>
              )
            }):<div className="noList" >
               暂无持仓数据
            </div>
          */}



          {/*
          <div className="superList" onClick={ ()=>{ this.goDetail("SF1006") }}>
            <div><span>60后智享财富</span><span></span></div>
            <div><span>当前资产</span><span>401.14</span></div>
            <div><span>最新收益</span><span>401.14</span></div>
          </div>
          
          <div className="superList" onClick={ ()=>{ this.goDetail("SF1009") }} >
            <div><span>金色起跑线</span><span></span></div>
            <div><span>当前资产</span><span>401.14</span></div>
            <div><span>最新收益</span><span>401.14</span></div>
          </div>

          <div className="superList" onClick={ ()=>{ this.goDetail("SF1005") }} >
            <div><span>锐意进取型</span><span></span></div>
            <div><span>当前资产</span><span>401.14</span></div>
            <div><span>最新收益</span><span>401.14</span></div>
          </div>
          */}

      {
            this.state.tipFlag?
             <AlerModleCommonn 
             btnTxt1="知道了"
             content={"投顾组合由于其底层基金净值更新时间不同，组合资产及收益分两次更新。一般为交易日当晚更新组合中华夏基金公募产品数据，次日15点后更新组合中非华夏基金公募产品数据。"} 
             contentSec={"遇特殊情况（分红、折算等）收益可能不准确，分红、折算确认后会自动修复。"}
             title="查理解密"
             handleClick1 = {()=>{this.setState({tipFlag:false})} }
           /> : null
          }
        </div>
            );
      }
}

class TabLineComponent extends Component {
      constructor(props) {
            super(props);
            this.state = {
                  tabName: '三个月',
                  data1: [],
                  data2: [],
                  historyData: {
                        HistoryRate: []
                  },
                  threeMonthDate: [],
                  threeMonthNav: [],
                  oneYearDate: [],
                  oneYearNav: [],
                  totalDate: [],
                  totalNav: [],
                  dataX:null,
                  dataY:null,
            };
      }
      componentWillMount() {
        let {
              dispatch,
              superFundCode
        } = this.props;
        let that = this;
        //this.callBackIncome(historyD.content)

        let beginDate = GetDateStr(getDateNow());
        let endDate = getDateNow();
        let data = {};
        data.fundCode = "";
        data.beginDate = beginDate;
        data.endDate = endDate;
        dispatch(getHistoryIcomeListSuper(data,this.handleCallback.bind(this),this));
      }
      handleCallback(data){
        let dataX = [];
        let dataY = [];
         for(let i=data.length-1; i>=0; i--){
            if(data[i].dayIncome != "--"){
              dataY.push(data[i].dayIncome);
              dataX.push(data[i].deadLine)
            }
         }
         this.setState({
          dataX,dataY,
         })
         // this.props._this.setState({
         //  loadingFlag:false
         // })

        console.log(data,"ffff",dataX,dataY)
      }
      callBackIncome(data) {
            console.log(data)
            const tempDate = ["2017/7/21", "2017/7/22", "2017/7/23", "2017/7/24", "2017/7/25", "2017/7/26", "2017/7/27", "2017/7/28", "2017/7/29",
                  "2017/7/30", "2017/7/31", "2017/8/1", "2017/8/2", "2017/8/3", "2017/8/4", "2017/8/5", "2017/8/6", "2017/8/7", "2017/8/8", "2017/8/9",
                  "2017/8/10", "2017/8/11", "2017/8/12", "2017/8/13", "2017/8/14", "2017/8/15", "2017/8/16", "2017/8/17", "2017/8/18",
                  "2017/8/19", "2017/8/20", "2017/8/21", "2017/8/22", "2017/8/23", "2017/8/24", "2017/8/25", "2017/8/26",
                  "2017/8/27", "2017/8/28", "2017/8/29", "2017/8/30", "2017/8/31", "2017/9/1", "2017/9/2", "2017/9/3",
                  "2017/9/4", "2017/9/5", "2017/9/6", "2017/9/7", "2017/9/8", "2017/9/9", "2017/9/10", "2017/9/11", "2017/9/12",
                  "2017/9/13", "2017/9/14", "2017/9/15", "2017/9/16", "2017/9/17", "2017/9/18", "2017/9/19", "2017/9/20", "2017/9/21"
            ];

            const tempNav = [24.3, 0.2, 0.1, 34.6, -21.9, -38.7, 24, 10.8, 0.2, 0.1, 8.9, 3.6, 3, -21.3, -1, 0.1, 0.2, 43.1, 22.8, -8, -39.2, -20.8, 0.2, 0.1, 84.2, 6.1, 30.5, -10.5, -13.9, 0.2, 0.1, 28.4, 7.1, 0.4, -46.6, 26.5, 0.2, 0.1, -6.9, -15.7, 45.5, 13, 47.7, 0.2, 0.1, -8.5, 35.9, -2.3, 1.8, -17.4, 0.1, 0.2, 48.7, 33.6, -7.2, 3.7, -8.7, 0, 0, 23.6, -2.7, 25.7, 8];

            let dateLength = tempDate.length;
            let threeMonthDate = tempDate.slice(dateLength - 7);
            let threeMonthNav = tempNav.slice(dateLength - 7);
            let oneYearDate = tempDate.slice(dateLength - 30);
            let oneYearNav = tempNav.slice(dateLength - 30);

            this.setState({
                  data1: threeMonthDate,
                  data2: threeMonthNav,
                  threeMonthDate: threeMonthDate,
                  threeMonthNav: threeMonthNav,
                  oneYearDate: oneYearDate,
                  oneYearNav: oneYearNav,
                  totalNav: tempNav,
                  totalDate: tempDate,
            });

      }
      handleTab(a) {
            let {
                  dispatch,
                  superFundCode
            } = this.props;
            console.log(superFundCode)

            let that = this;

            if (a == "三个月") {
                  //BtnYear(superFundCode,a)
                  let inData = {
                        superFundCode: superFundCode,
                        periodType: 3
                  }
                  that.setState({
                              tabName: "三个月",
                              data1: this.state.threeMonthDate,
                              data2: this.state.threeMonthNav
                        })
                        
            } else if (a == "近一年") {
                  //BtnYear(superFundCode,a)
                  let inData = {
                        superFundCode: superFundCode,
                        periodType: 12
                  }
                  that.setState({
                              tabName: "近一年",
                              data1: this.state.oneYearDate,
                              data2: this.state.oneYearNav
                        })
                       
            } else if (a == "成立以来") {
                  //BtnYear(superFundCode,a)
                  that.setState({
                        tabName: "成立以来",
                        data1: this.state.totalDate,
                        data2: this.state.totalNav
                  })
            }
      }
      render() {
            let {
                  tabName,
                  data1,
                  data2,
                  dataX,
                  dataY
            } = this.state;
            console.log(data1, data2)
            return (
                  <div>
          <div style={{ background:"#FFF"}}>
            {/*
              <div className="tabLinTitle">
                <span className={ tabName === "三个月" ? "clickTab" : ""} onClick={ ()=>{ this.handleTab("三个月") }} >三个月</span>
                <span className={ tabName === "近一年" ? "clickTab" : ""} onClick={ ()=>{ this.handleTab("近一年") }}>近一年</span>
                <span className={ tabName === "成立以来" ? "clickTab" : ""} onClick={ ()=>{ this.handleTab("成立以来") }}>成立以来</span>
              </div>
            */}
             <LineComponent data1 = { dataX } data2 = { dataY } /> 
          </div>
        </div>
            );
      }
}

class LineComponent extends Component {
      constructor(props) {
            super(props);
            this.state = {};
      }
      componentDidMount() {
            // var myChart = echarts.init(document.getElementById('SuperLine'));
            //  // 绘制图表
            //  let dataArr = [];
            //  this.props.data2 ? this.props.data2.map(function(item){
            //    dataArr.push(Util.newToFixed(item*100))
            //  }): null
            //  myChart.setOption(returnLineOption(this.props.data1,dataArr));
      }
      componentWillUpdate(nextProps, nextState) {

      }
      componentDidUpdate() {
          if (window.isLess47) {
             var myChart = echarts.init(document.getElementById('SuperLine'));
           }else{
              var myChart = echarts.init(document.getElementById('SuperLine'), null, {renderer: 'svg'});
           }
            // 绘制图表
            let dataArr = [];
            // this.props.data2 ? this.props.data2.map(function(item) {
            //       dataArr.push(Util.newToFixed(item * 100))
            // }) : null
            myChart.clear();
            myChart.setOption(lineOption(this.props.data1, this.props.data2));
      }
      render() {
            let width = window.screen.width;
            return (
                  <div id="SuperLine" style={{ width:width , height:360, paddingLeft:'8px' }}></div>
            );
      }
}


/*折线图option*/
export function lineOption(dataName, dataSouce) {
      let pValue = 0;
      if(width<350){
        pValue = 0;
      }else if(width < 400){
        pValue = 13;
      }else{
        pValue = 23;
      }
      let option = {
            title: {
                  text: ''
            },
            animation: window.isLess47,
            grid: {
                  y: '13%',
                  left: 37
            },
            // tooltip: {},
            // legend: {
            //     data:[]
            // },
            tooltip : {
              show:true,
              trigger: 'axis',
              alwaysShowContent:true,
              position:[width/2,0],
              padding:[16,300,0,pValue],
              axisPointer:{
                    type: 'line',
                    lineStyle: {
                        color: '#48b',
                        width: 1,
                        type: 'dashed'
                    },
                    crossStyle: {
                        color: '#1e90ff',
                        width: 1,
                        type: 'dashed'
                    },
                    shadowStyle: {
                        color: 'rgba(150,150,150,0.3)',
                        width: 'auto',
                        type: 'default'
                    }
              },
              backgroundColor:"#FFF",
              textStyle:{
                fontSize:11,
                paddingLeft:5,
                paddingRight:5,
              },
              formatter:'<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:'+`${true?'rgb(249,98,94)':'#f0f'}`+'>{c0}%</span> </div>'

            },
            xAxis: [{
                type: 'category',
                boundaryGap: false,
                data: dataName,
                // name:'(年份)',
                axisLine: {
                      lineStyle: {
                            width: 1,
                            color: "#CCC"
                      }
                },
                axisTick: {
                      lineStyle: {
                            width: 0,
                            color: "#9BC4D8"
                      }
                },
            }],
            axis: [{
                  axisLline: {
                        show: true,
                        lineStyle: {
                            color: '#99C4D7',
                            width: 2,
                            type: 'dashed'
                        }
                  },
                  splitArea: {
                        areaStyle: {
                              color: [
                                    'rgba(250,250,250,0.3)',
                                    'rgba(200,200,200,0.3)'
                              ]
                        }
                  }
            }, ],
            yAxis: [{
                  type: 'value',
                  scale: true,
                  // name:'(人)',
                  axisLine: {
                        lineStyle: {
                              width: 0,
                              color: "rgb(160,167,176)"
                        }
                  },
                  axisTick: {
                        lineStyle: {
                              width: 0,
                              color: "#9BC4D8"
                        }
                  },
                  axisLabel: {
                        rotate: 0,
                        formatter: '{value}'
                  }
            }],
            series: [{
                  name: '日收益',
                  type: 'line',
                  smooth: true,
                  hoverAnimation: false,
                  data: dataSouce,
                  itemStyle: {
                        normal: {
                              color: '#fa063a',
                              /*#53C6E0*/
                              lineStyle: {
                                    color: '#fa063a'
                              }
                        }
                  },
            }]
      }
      return option;
}

function mapStateToProps(state, ownProps) {
      return {
            SupperFundHome: state.SupperFundHome,
      }
}
export default connect(mapStateToProps)(SuperFundList);

function GetDateStr(beginDate,AddDayCount=-15) {   
   var dd = new Date(beginDate.replace(/\-/g,'/'));  
   dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期  
   var y = dd.getFullYear();   
   var m = (dd.getMonth()+1)<10?"0"+(dd.getMonth()+1):(dd.getMonth()+1);//获取当前月份的日期，不足10补0  
   var d = dd.getDate()<10?"0"+dd.getDate():dd.getDate();//获取当前几号，不足10补0  
   return y+"-"+m+"-"+d;   
}





// WEBPACK FOOTER //
// ./src/components/fundDetail/SuperFundList.js